import styled from 'styled-components';

const TableColumnFilterContainer = styled.div``;

export default TableColumnFilterContainer;
